exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fader[data-v-648564e3] {\n  position: absolute;\n  height: 50px;\n  width: 100%;\n  bottom: 0;\n  background: linear-gradient(0deg, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0.5074404762) 50%, rgba(255, 255, 255, 0) 100%);\n}\n.feature[data-v-648564e3] {\n  font-size: 0.875rem;\n}\n.heading-box .heading[data-v-648564e3] {\n  margin-bottom: 0;\n}\n.feature-icon-box[data-v-648564e3] {\n  width: 20px;\n}\n.fade-enter-active[data-v-648564e3],\n.fade-leave-active[data-v-648564e3] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-648564e3], .fade-leave-to[data-v-648564e3] {\n  opacity: 0;\n}", ""]);

// exports
